module.exports = __webpack_public_path__ + "static/todd-profile-6573e10e6cdb66e23aa156ec64d0542d.png";